(function(){
    'use strict'

    angular
    .module('app.usuarios')
    .controller('RecuperarPassword', RecuperarPassword);

    RecuperarPassword.$inject = ['$animationsSrv', '$scope', 'UsuariosService', 'logger', '$location'];

    function RecuperarPassword($animationsSrv, $scope, UsuariosService, logger, $location) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.interface = {
            loginError: false,
            passwordSuccess: false,
            passwordError: false
        };

        vm.data = {
            email: '',
        };

        vm.recuperarPassword = function(){
            $scope.submitted = true;

            if($scope.loginForm.$valid){
                var promise = UsuariosService.recuperarPassword(vm.data);
                vm.interface.loginError = false;
                promise.then(function(response){

                    if (response.data != null) {  
                    
                        $location.path('/'); 
                        logger.success('Los datos de tu contraseña se enviarón a tu cuenta de Email'); 

                    } else {
                        vm.interface.loginError = true;
                        logger.error('El Email no esta registrado en el sistema.');
                    } 

                }).catch(function(error){
                    logger.error(error.data.Message);
                    vm.interface.loginError = true;
                });
            }
        };

    }
})();